import { 
  Program, 
  ProgramFormData
} from '../types/program';
import { appApi } from '../../../store/app.api';
import { appEndpoint } from '../../../store/app.endpoint';
import { CommandRequest } from '../../../libs/auth/utilities/command-request';

export const programsApi = appApi.injectEndpoints({
  endpoints: (build) => ({

    // ✅ Fetch all programs
    getPrograms: build.query<Program[], void>({
      query: () => ({
        url: appEndpoint.getPrograms,
        method: 'get',
      }),
      providesTags: ['Programs'],
      transformResponse: (response: any) => response.data, // make sure it returns Program[]
    }),
    
    // ✅ Fetch a single program by ID
    getProgramById: build.query<Program, string>({
      query: (id) => ({
        url: `${appEndpoint.getPrograms}/${id}`,
        method: 'get',
      }),
      providesTags: (result, error, id) => [{ type: 'Programs', id }],
      transformResponse: (response: any) => response.data, // make sure it returns Program
    }),

    // ✅ Add new program
    addProgram: build.mutation<any, CommandRequest>({
      query: (data) => ({
        url: appEndpoint.addProgram,
        method: 'post',
        data: data.body, // body should only contain: name, description, objectives, achievements
      }),
      invalidatesTags: (result) => (result ? ["Programs"] : []),
    }),

    // ✅ Update existing program
    updateProgram: build.mutation<any, CommandRequest>({
      query: (data) => ({
        url: `${appEndpoint.updateProgram}/${data.id}?_method=put`,
        method: 'post',
        data: data.body, // same: only send allowed fields
      }),
      invalidatesTags: (result) => (result ? ["Programs"] : []),
    }),

    // ✅ Delete program
    deleteProgram: build.mutation<void, string>({
      query: (id) => ({
        url: `${appEndpoint.deleteProgram}/${id}`,
        method: 'delete',
      }),
      invalidatesTags: ['Programs'],
    }),

  }),
  overrideExisting: false,
});

export const {
  useGetProgramsQuery,
  useGetProgramByIdQuery,
  useAddProgramMutation,
  useUpdateProgramMutation,
  useDeleteProgramMutation,
} = programsApi;
